import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { PaymentMandateData } from '../model/paymentMandateData';
import paymentMandateFuncs from '../model/paymentMandateData';
import { PaymentMandateHistoryEntry } from '../model/paymentMandateHistoryEntry';

export interface BackendPaymentData {
  getPaymentMandate(
    applicationUserId: string
  ): AxiosPromise<PaymentMandateData>;
  updatePaymentMandate(paymentMandate: PaymentMandateData): AxiosPromise<any>;
  getPaymentMandateHistory(
    applicationUserId: string
  ): AxiosPromise<PaymentMandateHistoryEntry[]>;
}

export const DefaultBackendPaymentData: BackendPaymentData = {
  getPaymentMandate(applicationUserId) {
    return instance.get<PaymentMandateData>(
      `${URLS.paymentData}/GetPaymentMandate/${applicationUserId}`
    );
  },
  updatePaymentMandate(paymentMandate) {
    return instance.post<any>(
      `${URLS.paymentData}/UpdatePaymentMandate`,
      paymentMandateFuncs.toAPI(paymentMandate)
    );
  },
  getPaymentMandateHistory(applicationUserId) {
    return instance.get<PaymentMandateHistoryEntry[]>(
      `${URLS.paymentData}/GetPaymentMandateHistory/${applicationUserId}`
    );
  },
};
